import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { NotificationService } from 'src/app/Service/notification.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import Hls from 'hls.js';
import flvjs from 'flv.js';
import axios_2 from 'src/app/Service/axios-dotone';
import { VoiceRecordModalComponent } from './components/voice-record-modal/voice-record-modal.component';
import { ShareVideoModalComponent } from './components/share-video-modal/share-video-modal.component';
declare let $: any;

@Component({
  selector: 'video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css'],
})
export class VideoPlayerComponent implements OnInit, OnDestroy {
  @Input() isHideInfo: boolean = false;
  @Input() src!: string;
  @Input() maxHeight: string = 'initial';
  @Input() obj_Cam!: any;
  @Input() expiresAt!: number;
  @Input() tripId!: number;
  @Input() ScreenShot!: boolean;
  @ViewChild('video') videoRef!: ElementRef<HTMLVideoElement>;
  @ViewChild('voiceRecordModal') voiceRecordModal!: VoiceRecordModalComponent;
  @ViewChild('shareVideoModal') shareVideoModal!: ShareVideoModalComponent;

  isPlaying = false;
  private hls?: Hls;
  private flvPlayer?: flvjs.Player;

  constructor(
    private tooltip: NotificationService,
    private gurdService: GurdServiceService,
    private otherService: OtherService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    if (this.expiresAt) {
      const targetTime = this.expiresAt * 1000;

      const now = Date.now();

      const delay = targetTime - now;

      if (delay > 0) {
        setTimeout(() => {
          this.terminateStreaming();
        }, delay);
      } else {
        this.terminateStreaming();
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.togglePlay();
    }, 400);

    const video = this.videoRef.nativeElement;

    video.muted = true;

    if (this.src.endsWith('.m3u8')) {
      if (Hls.isSupported() && !this.isIOS()) {
        this.hls = new Hls();

        this.hls.loadSource(this.src);

        this.hls.attachMedia(video);
      } else {
        video.src = this.src;

        video.setAttribute('playsinline', 'true');

        video.setAttribute('webkit-playsinline', 'true');
      }
    } else if (this.src.endsWith('.flv')) {
      if (flvjs.isSupported()) {
        this.flvPlayer = flvjs.createPlayer({ type: 'flv', url: this.src });

        this.flvPlayer.attachMediaElement(video);

        this.flvPlayer.load();
      } else {
        video.src = this.src;

        video.muted = true;
      }
    } else {
      video.src = this.src;
    }
  }

  ngOnDestroy(): void {
    if (this.hls) {
      this.hls.destroy();
    }

    if (this.flvPlayer) {
      this.flvPlayer.destroy();
    }
  }

  private isIOS(): boolean {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window)
    );
  }

  togglePlay() {
    const video = this.videoRef.nativeElement;

    if (video.paused) {
      video.play();

      this.isPlaying = true;
    } else {
      video.pause();
      this.isPlaying = false;
    }
  }

  openVoiceRecordModal() {
    this.voiceRecordModal?.open();
  }

  liveShare(): void {
    this.shareVideoModal?.open();
  }

  takeScreenshot() {
    const video = this.videoRef.nativeElement;
    const canvas = document.createElement('canvas');

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext('2d');

    if (context) {
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = `screenshot-${this.tripId ?? new Date()}.png`;
      link.click();
    }
  }

  async openLink() {
    this.otherService.Showspinner();
    const model = this.otherService.stringNumberToNumber(
      this.shareVideoModal.mdlTempAccess.value,
    );
    const resp = await axios_2.post(`FleetYar_VehicleliveURL`, model);
    this.otherService.nonespinner();
    let res = resp.data;
    if (res.ISSessionExpired == true) {
      this.tooltip.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], {
        queryParams: { error: 'x12333310' },
      });

      return;
    }
    if (res.iResult == 0) return this.tooltip.showError(res.strError);
    window.open(res.LiveURL, '_blank');
  }

  private async terminateStreaming() {
    const video = this.videoRef.nativeElement;

    video.pause();

    this.isPlaying = false;

    const key = {
      strKey: this.gurdService.decrypt(localStorage.getItem('liveKey')!),
    };

    await axios_2.post(
      `CancelVideoStream`,
      this.otherService.stringNumberToNumber(key),
    );

    // this.tooltip.showError('پایان مشاهده فیلم کابین!');

    $.confirm({
      title: 'پایان مشاهده فیلم کابین!',

      content: '',

      type: '',

      buttons: {
        ok: {
          text: 'بستن',

          btnClass: 'btn-secondary',

          keys: ['enter'],
        },
      },
    });
  }
  
}
